module.exports = __webpack_public_path__ + "img/Porto Apartment - 12 of 85.4cd7b2af.jpeg";